import React from 'react';
import styled from '@emotion/styled';
import { ReactComponent as BackIcon } from 'Icons/back.svg';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 16px;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  svg {
    width: 24px;
    height: 24px;
    path {
      fill: #597EF7;
    }
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
`;

const Header = ({ title }) => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <HeaderContainer>
      <BackButton onClick={handleBack}>
        <BackIcon fill={'#597EF7'} />
      </BackButton>
      <Title>{title}</Title>
    </HeaderContainer>
  );
};

export default Header; 